export const contractToOption = contract => ({
  label: contract?.tag+' - '+contract?.name,
  value: contract?.id,
})
